const API_URL = import.meta.env.VITE_API_URL;
const AUTH_LOGIN_ENDPOINT = import.meta.env.VITE_AUTH_LOGIN_ENDPOINT;
const AUTH_GOOGLE_ENDPOINT = import.meta.env.VITE_AUTH_GOOGLE_ENDPOINT;
const AUTH_GOOGLE_CALLBACK_ENDPOINT = import.meta.env.VITE_AUTH_GOOGLE_CALLBACK_ENDPOINT;
const AUTH_VALIDATE_ENDPOINT = import.meta.env.VITE_AUTH_VALIDATE_ENDPOINT;

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Add auth token interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;

interface LoginCredentials {
  email: string;
  password: string;
}

export async function loginWithEmail(credentials: LoginCredentials) {
  try {
    const { data } = await axiosInstance.post(
      AUTH_LOGIN_ENDPOINT,
      credentials
    );
    return data;
  } catch (error) {
    let errorMessage = 'Login failed';
    if (axios.isAxiosError(error)) {
      errorMessage = error.response?.data?.message || error.message || errorMessage;
    }
    throw new Error(errorMessage);
  }
}

export function getGoogleAuthUrl(): string {
  return `${API_URL}${AUTH_GOOGLE_ENDPOINT}`;
}

export async function handleGoogleCallback(code: string) {
  try {
    const response = await axiosInstance.post(
      AUTH_GOOGLE_CALLBACK_ENDPOINT,
      { code }
    );
    
    // Check response structure - some APIs nest data in a data property
    const responseData = response.data.data || response.data;
    
    // Ensure we have a token in the response
    if (!responseData.token) {
      console.error("API Client: Invalid response format:", responseData);
      throw new Error("Invalid authentication response format");
    }
    
    return responseData;
  } catch (error) {
    let errorMessage = 'Google authentication failed';
    if (axios.isAxiosError(error)) {
      errorMessage = error.response?.data?.message || error.message || errorMessage;
    }
    throw new Error(errorMessage);
  }
}

// Function to validate the token with the backend
export async function validateToken(token: string): Promise<boolean> {
  try {
    await axiosInstance.get(AUTH_VALIDATE_ENDPOINT, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return true;
  } catch (error) {
    return false;
  }
} 